import { ENUM_TIER_NAME } from 'utils/enum';
import { LevelFormDataType } from 'utils/types';

export const EMPTY_FORM_DATA: LevelFormDataType = {
  title: '',
  rewards: [
    {
      reward_type: 'Discount',
      reward_quantity: null
    },
    {
      reward_type: 'Free Delivery',
      reward_quantity: null
    }
  ],
  max_points: null,
  tier_image: null,
  complimentary_meals: []
};

export const TIER_NAME_OPTIONS = [
  { text: 'Tier 1 - Foodie', value: ENUM_TIER_NAME.FOODIE },
  { text: 'Tier 2 - Taster', value: ENUM_TIER_NAME.TASTER },
  { text: 'Tier 3 - Gourmet', value: ENUM_TIER_NAME.GOURMET },
  { text: 'Tier 4 - Feast Master', value: ENUM_TIER_NAME.FEAST_MASTER },
  { text: 'Tier 5 - Bon Vivant', value: ENUM_TIER_NAME.BON_VIVANT }
];
